import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Clerk publishable key selection by hostname (Emergent support's workaround):
// the live production domains use the dedicated LIVE key; every other host
// (Preview) uses the existing development publishable key.
const LIVE_HOSTS = ["pcevents.app", "www.pcevents.app"];
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLiveHost = LIVE_HOSTS.includes(hostname);
const clerkPublishableKey = isLiveHost
  ? process.env.REACT_APP_CLERK_PUBLISHABLE_KEY_LIVE
  : process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

// On a live hostname we must NEVER silently fall back to the development key.
// If the production publishable key is missing, fail loudly instead of booting
// against the wrong Clerk instance.
if (isLiveHost && !clerkPublishableKey) {
  root.render(
    <div style={{ maxWidth: 560, margin: "15vh auto", padding: 24, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
      <h1 style={{ fontSize: 20, marginBottom: 12 }}>Configuration required</h1>
      <p style={{ color: "#555", lineHeight: 1.5 }}>
        This production site is missing its Clerk publishable key
        (<code>REACT_APP_CLERK_PUBLISHABLE_KEY_LIVE</code>). Sign-in is disabled until it is configured.
      </p>
    </div>,
  );
} else {
  root.render(
    <React.StrictMode>
      <ClerkProvider publishableKey={clerkPublishableKey} afterSignOutUrl="/">
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ClerkProvider>
    </React.StrictMode>,
  );
}
